<template>
    <b-card-group
        class="home-menu-cards"
        deck
    >
        <b-card
            v-for="(card, index) in filteredCards"
            :key="index"
            body-class="text-center"
            class="cursor-pointer"
            @click="handleCardClick(card.route)"
        >
            <b-img
                :src="card.illustration"
                class="illustration"
            />

            <p class="title mt-3 mb-md-0">
                {{ card.title }}
            </p>

            <div v-if="isMobile">
                <p class="description">
                    {{ card.description }}
                </p>

                <router-link
                    class="link"
                    :to="card.route"
                >
                    {{ card.linkText }}
                </router-link>
            </div>
        </b-card>
    </b-card-group>
</template>

<script>
    import './HomeMenuCards.scss';
    import './HomeMenuCards.mobile.scss';
    import {HOME_IMAGES} from "../../../../helpers/images";
    import LandingPageAppResource,{SECTIONS} from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";

    export default {
        name: "HomeMenuCards",

        props: {
            isMobile: {
                type: Boolean,
                required: true,
            },
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            },
        },

        data(){
            return {
                cards: [
                    {
                        illustration: HOME_IMAGES.BUY,
                        title: 'Buy',
                        description: 'Search our listings and find your dream home.',
                        linkText: 'View Listings',
                        route: {name: 'landing-page.buy'},
                        slug: SECTIONS.BUY,
                    },
                    {
                        illustration: HOME_IMAGES.SELL,
                        title: 'Sell',
                        description: 'Let\'s explore your options and pick the one that works best for you.',
                        linkText: 'View Options',
                        route: {name: 'landing-page.sell'},
                        slug: SECTIONS.SELL,
                    },
                    {
                        illustration: HOME_IMAGES.FINANCE,
                        title: 'Finance',
                        description: 'Get pre-qualified by a lender to purchase a home.',
                        linkText: 'Get Pre-Qualified',
                        route: {name: 'landing-page.finance'},
                        slug: SECTIONS.FINANCE,
                    },
                    {
                        illustration: HOME_IMAGES.TRADE,
                        title: 'Trade',
                        description: 'Secure your next home without the risks of selling first.',
                        linkText: 'Learn More',
                        route: {name: 'landing-page.trade'},
                        slug: SECTIONS.TRADE,
                    },
                ]
            };
        },

        computed: {
            filteredCards() {
                return this.cards.filter((link) => {
                    return this.landingPage.hasOwnProperty('activePages') &&
                        this.landingPage.activePages.includes(link.slug) && link.slug !== SECTIONS.FINANCE;
                });
            }
        },
        methods: {
            handleCardClick(route) {
                this.$router.push(route);
            },
        },
    };
</script>
